import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import KorshaLogo from './KorshaLogo';

const TOPICS = [
  '🌐 Web App',
  '📱 Mobile App',
  '🤖 AI Integration',
  '🎨 UI/UX Design',
  '☁️ Cloud Setup',
  '🔧 Just Brainstorm',
];

const Contact = () => {
  const [activeTopics, setActiveTopics] = useState([]);
  const [form, setForm] = useState({ name: '', email: '', topic: '', message: '' });
  const [status, setStatus] = useState('idle');

  const toggleTopic = (topic) => {
    setActiveTopics(prev =>
      prev.includes(topic) ? prev.filter(t => t !== topic) : [...prev, topic]
    );
  };

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    const templateParams = {
      from_name: form.name,
      from_email: form.email,
      topic: form.topic || 'New Project',
      message: form.message,
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        setStatus('success');
        setForm({ name: '', email: '', topic: '', message: '' });
      })
      .catch(() => {
        setStatus('error');
      });
  };

  return (
    <section id="contact">
      <div className="container contact-inner">
        {/* Left */}
        <div>
          <span className="section-tag">Contact</span>
          <h2 className="section-title">
            LET'S BUILD<br />
            <span className="gradient-text">SOMETHING</span><br />
            AMAZING
          </h2>
          <div className="glow-line" />
          <p className="contact-tagline">
            Have a project in mind? Want to brainstorm an idea? I'm all ears — and always excited to explore new possibilities.
          </p>

          <div className="glass-card brainstorm-block">
            <div className="brainstorm-header">
              <span className="brainstorm-icon">💡</span>
              <div>
                <div className="brainstorm-title">Brainstorm Session</div>
                <div className="brainstorm-sub">Let's discuss and build it!</div>
              </div>
            </div>
            <p className="brainstorm-text">
              No full spec yet? That's fine. I thrive in the early stages — helping shape raw ideas into real products. Drop a line and let's start the conversation.
            </p>
            <div className="brainstorm-topics">
              {TOPICS.map(topic => (
                <button
                  key={topic}
                  className={`topic-chip${activeTopics.includes(topic) ? ' active' : ''}`}
                  onClick={() => toggleTopic(topic)}
                >
                  {topic}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Right: Form */}
        <div>
          <div className="glass-card form-card">
            <div className="form-head">
              <h3>Start a Conversation</h3>
              <p>I typically respond within 24 hours.</p>
            </div>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-field">
                  <label>Your Name *</label>
                  <input
                    name="name"
                    type="text"
                    placeholder="e.g. Alex Johnson"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-field">
                  <label>Email *</label>
                  <input
                    name="email"
                    type="email"
                    placeholder="alex@example.com"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-field">
                <label>What are you looking to build?</label>
                <input
                  name="topic"
                  type="text"
                  placeholder="Describe your idea..."
                  value={form.topic}
                  onChange={handleChange}
                />
              </div>
              <div className="form-field">
                <label>Your Message *</label>
                <textarea
                  name="message"
                  rows="5"
                  placeholder="Tell me about your project, timeline, and goals..."
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="btn-primary form-submit" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending...' : status === 'success' ? 'Sent!' : 'Send Message ↗'}
              </button>
              {status === 'success' && <p className="form-note" style={{color: '#4ade80'}}>Message sent successfully!</p>}
              {status === 'error' && <p className="form-note" style={{color: '#f87171'}}>Failed to send. Please try again.</p>}
              {(status === 'idle' || status === 'sending') && <p className="form-note">Your message will be sent directly.</p>}
            </form>
          </div>
        </div>
      </div>

      {/* CTA Strip */}
      <div className="container">
        <div className="cta-strip">
          <div>
            <div className="cta-tagline gradient-text">The Future, Drawn to You.</div>
            <div className="cta-sub">— KORSHA · korsha.ai</div>
          </div>
          <KorshaLogo size={80} opacity={0.4} />
        </div>
      </div>
    </section>
  );
};

export default Contact;
